<template>
  <div class="order">
    <search
      status="14"
      :recordsSearchObj="recordsSearchObj"
      :carTypeList="carTypeList"
      @handleSearch="handleSearch"
      type="settlement"
    />
    <div class="table-container">
      <el-table
        :data="tableData"
        border
        v-loading="loading"
        @filter-change="filterChange"
      >
        <el-table-column type="selection" width="40" align="center">
        </el-table-column>
        <el-table-column type="index" label="序号" width="50" align="center">
        </el-table-column>
        <el-table-column
          prop="claimType"
          label="索赔类型"
          width="100"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.claimType === 1 ? '质量整改' : '整车索赔' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="claimStatementNum"
          label="索赔单号"
          min-width="120"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="customerAccountNum"
          label="客户账号"
          min-width="100"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="customerCountry"
          label="国家"
          min-width="120"
          show-overflow-tooltip
          align="center"
          column-key="customerCountry"
          :filters="this.countryList"
          :filter-method="filterHandler"
        >
          <template slot-scope="scope">
            <p>{{ getCountry(scope.row.customerCountry) }}</p>
          </template>
        </el-table-column>
        <el-table-column
          prop="carModel"
          label="车型"
          min-width="120"
          show-overflow-tooltip
          align="center"
          column-key="carModel"
          :filters="this.carTypeList"
          :filter-method="filterHandler"
        >
        </el-table-column>
        <el-table-column
          prop="vin"
          label="VIN"
          min-width="120"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="faultPartNameZh"
          label="主因故障件名称"
          min-width="120"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="faultPartNumber"
          label="主因故障件代码"
          min-width="200"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="repairPlan"
          label="维修方案"
          min-width="120"
          show-overflow-tooltip
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.repairPlan === 0 ? "维修" : "" }}
            {{ scope.row.repairPlan === 1 ? "更换" : "" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="auditResultDisplay"
          label="状态"
          min-width="120"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          v-for="(item, index) in responsibilityPartListMaxLength"
          :key="index"
          :label="`责任方${numberToChinese(item)}`"
          min-width="160"
          show-overflow-tooltip
          align="center"
        >
          <el-table-column
            label=""
            min-width="160"
            show-overflow-tooltip
            align="center"
          >
            <template slot-scope="scope">
              {{
                scope.row.responsibilityPartList &&
                scope.row.responsibilityPartList[index]
                  ? scope.row.responsibilityPartList[index]
                      .responsibilitySupplier ||
                    scope.row.responsibilityPartList[index]
                      .responsibilityDepartment
                  : "无"
              }}
            </template>
          </el-table-column>
          <el-table-column
            label=""
            min-width="90"
            show-overflow-tooltip
            align="center"
          >
            <template slot-scope="scope">
              {{
                scope.row.responsibilityPartList &&
                scope.row.responsibilityPartList[index]
                  ? `${scope.row.responsibilityPartList[index].responsibilityRatio}%`
                  : "无"
              }}
            </template>
          </el-table-column>
          <el-table-column
            label=""
            min-width="90"
            show-overflow-tooltip
            align="center"
          >
            <template slot-scope="scope">
              {{
                scope.row.responsibilityPartList &&
                scope.row.responsibilityPartList[index]
                  ? scope.row.responsibilityPartList[index].secondDamages
                    ? `¥${scope.row.responsibilityPartList[index].secondDamages}`
                    : "无"
                  : "无"
              }}
            </template>
          </el-table-column>
        </el-table-column>
        <!-- <el-table-column
          label="责任方"
          min-width="160"
          show-overflow-tooltip
          align="center"
        >
          <template slot-scope="scope">
            <el-tooltip placement="left">
              <div slot="content">
                <div class="responsibilityPartListTip">
                  <div class="item">责任方</div>
                  <div class="item">责任占比</div>
                  <div class="item2">二次索赔金额</div>
                </div>
                <div
                  class="responsibilityPartListTip"
                  v-for="(item, index) in scope.row.responsibilityPartList"
                  :key="index"
                >
                  <div class="item">{{ item.responsibilityDepartment }}</div>
                  <div class="item">{{ item.responsibilityRatio }}%</div>
                  <div class="item2">
                    {{ item.secondDamages ? `¥${item.secondDamages}` : "--" }}
                  </div>
                </div>
              </div>
              <span class="textAreaTipBtn">{{
                scope.row.responsibilityDepartment
              }}</span>
            </el-tooltip>
          </template>
        </el-table-column> -->
        <el-table-column
          prop="totalCostOfWork"
          label="工时费"
          min-width="120"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="freight"
          label="运费"
          min-width="120"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="tariff"
          label="关税"
          min-width="120"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="materialTotalCost"
          label="材料费"
          min-width="120"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="otherTotalCost"
          label="其他费用"
          min-width="120"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop=""
          label="一次索赔总费用"
          min-width="160"
          show-overflow-tooltip
          align="center"
        >
          <template slot-scope="scope">
            <span
              v-if="
                scope.row.responsibilityPartList &&
                  scope.row.responsibilityPartList.length > 0
              "
            >
              ¥{{
                scope.row.currency === 1
                  ? (scope.row.claimTotalCost * exchangeRate).toFixed(2)
                  : scope.row.claimTotalCost
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="currency"
          label="结算币种"
          min-width="120"
          show-overflow-tooltip
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.currency === 0 ? "CNY" : "USD" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="settlementTime"
          label="结算日期"
          min-width="160"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="settlementStaff"
          label="结算人"
          min-width="120"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          width="160px"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="toDetail(scope.row)"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="fenye">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
          :current-page="page"
          :page-sizes="[10, 15, 20, 30]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { settlementDetailList } from "@/api/seek";
import search from "@/components/claimantSearch";
import { getNations } from "@/util/getNation";
import { getSession, setStorage } from "@/util/localStor";
import { getDownloadFiles } from "@/util/downFile";
import { getDictItem, getDictValue } from "@/util/dict";
import { numberToChinese } from "@/util/index";

export default {
  components: {
    search
  },
  data() {
    const { data, pageNum, pageSize } = this.$route?.query?.searchObj
      ? JSON.parse(this.$route?.query?.searchObj)
      : {};
    return {
      searchInfo: {
        settlementId: this.$route.query?.settlementId
      },
      loading: false,
      tableData: [],
      page: Number(pageNum) || 1,
      pageSize: Number(pageSize) || 10,
      total: 0,
      exportLoading: false,
      recordsSearchObj: data,
      countryList: [],
      searchData: {},
      carTypeList: [],
      responsibilityPartListMaxLength: 0, // 责任方列表最大长度
      exchangeRate: 1 // 汇率
    };
  },
  async mounted() {
    this.searchInfo = this.recordsSearchObj
      ? JSON.parse(JSON.stringify(this.recordsSearchObj))
      : this.searchInfo;
    Object.values(getSession("nationList")).map(item => {
      if (item.id != 0) {
        this.countryList.push({ text: item.name, value: item.id });
      }
    });
    await this.getExchangeRate();
    this.getList();
    // 获取车型
    const carTypeList = await getDictItem("carType");
    carTypeList.map(item => {
      this.carTypeList.push({ text: item.value, value: item.code });
    });
  },
  methods: {
    numberToChinese,
    // 获取汇率
    async getExchangeRate() {
      const exchangeRateDict = await getDictItem("exchangeRate");
      const exchangeRateItem = getDictValue(exchangeRateDict, "USD/CNY");
      this.exchangeRate = exchangeRateItem?.codeText || this.exchangeRate;
    },
    // 获取二赔总金额
    getDamages({ responsibilityPartList }) {
      var sum = 0;
      responsibilityPartList.map(item => {
        sum += item.secondDamages;
      });
      return sum.toFixed(2);
    },
    // 获取国家
    getCountry(data) {
      let country = getNations(data);
      return country;
    },
    // 搜索
    handleSearch(data) {
      this.searchData = JSON.parse(JSON.stringify(data));
      let obj = data;
      this.searchInfo.claimStatementNum = obj.claimStatementNum;
      this.searchInfo.customerAccountNum = obj.customerAccountNum;
      this.searchInfo.customerName = obj.customerName;
      this.searchInfo.lbjzy = obj.lbjzy;
      if (
        typeof obj.countryId === "string" ||
        typeof obj.countryId === "number"
      ) {
        this.searchInfo.countryId =
          obj.countryId && obj.countryId != "0" ? [obj.countryId] : [];
      }
      if (typeof obj.carModel === "string") {
        this.searchInfo.carModel = obj.carModel ? [obj.carModel] : [];
      }
      this.searchInfo.carBrand = obj.carBrand;
      this.searchInfo.vin = obj.vin;
      this.searchInfo.faultPartNumber = obj.faultPartNumber;
      this.searchInfo.faultPartNameZh = obj.faultPartNameZh;
      this.searchInfo.responsibilityDepartment = obj.responsibilityDepartment;
      this.searchInfo.supplierName = obj.supplierName;
      this.page = 1;
      this.pageSize = 10;
      this.getList();
    },
    // 记录当前列表搜索条件
    recordSearchObj() {
      this.$router.replace(
        "/claimant/claimSettlementDetailList?settlementId=" +
          this.$route.query.settlementId +
          "&searchObj=" +
          JSON.stringify({
            data: {
              ...this.searchInfo
            },
            pageNum: this.page,
            pageSize: this.pageSize
          })
      );
    },
    // 查看
    toDetail(data) {
      setStorage("claimantData", data);
      this.recordSearchObj();
      this.$router.push({
        path: "/claimant/claimSettlementDetail",
        query: { claimantId: data.claimStatementNum, operate: "查看详情" }
      });
    },
    // 每页显示条数
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    // 翻页
    handlePageChange(val) {
      this.page = val;
      this.getList();
    },
    // 获取列表
    async getList() {
      this.loading = true;
      let query = {
        data: {
          ...this.searchInfo
        },
        page: {
          pageNum: this.page,
          pageSize: this.pageSize
        }
      };
      const res = await settlementDetailList(query);
      if (res.status == 0) {
        this.tableData = res.data.records;
        this.total = res.data.count;
        this.loading = false;
        this.responsibilityPartListMaxLength = 0;
        res.data.records.map(item => {
          if (
            item.responsibilityPartList &&
            item.responsibilityPartList.length >
              this.responsibilityPartListMaxLength
          ) {
            this.responsibilityPartListMaxLength =
              item.responsibilityPartList.length;
          }
        });
      }
      this.loading = false;
    },
    filterHandler(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },
    filterChange(value) {
      // 国家过滤
      if (value.customerCountry) {
        if (value.customerCountry.length === 0) {
          this.searchInfo.countryId = this.searchData.countryId || [];
        } else {
          this.searchInfo.countryId = value.customerCountry;
        }
      }
      // 车型过滤
      if (value.carModel) {
        if (value.carModel.length === 0) {
          this.searchInfo.carModel = this.searchData.carModel || [];
        } else {
          this.searchInfo.carModel = value.carModel;
        }
      }
      this.getList();
    }
  }
};
</script>
<style lang="scss" scoped>
.table-container {
  padding: 0 7px 0 23px;
}
.responsibilityPartListTip {
  display: flex;
  text-align: center;
  padding: 18px 20px;
  .item {
    width: 120px;
  }
  .item2 {
    width: 180px;
  }
}
</style>
